// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import moment from "moment"
// import Navbar from "../Components/Navbar";
// import Footer from "../Components/Footer";
// import PageTitle from "../Components/PageTitle";
// import Header from "../Components/Header";
// import OnlineExamsBanner from "../assets/OnlineExams.png";
// import axios from "../axiosInstance";
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Chip,
//   Modal,
//   TextField,
//   Divider,
//   Stack,
//   IconButton,
//   Alert,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Close as CloseIcon,
//   Download as DownloadIcon,
//   School as SchoolIcon,
//   AccessTime as AccessTimeIcon,
//   CalendarToday as CalendarTodayIcon,
//   Assignment as AssignmentIcon,
//   Star as StarIcon,
//   Cancel as CancelIcon,
//   Login as LoginIcon,
//   Star,
//   Phone as PhoneIcon,
//   Cake as CakeIcon,
//   Person as PersonIcon,
//   ParentalHelp as ParentIcon,
//   Email as EmailIcon,
//   LocationOn as LocationIcon,
// } from "@mui/icons-material";
// import logo from "../assets/mainLogo.jpg";

// // Brand Colors
// const primaryColor = '#065A79';
// const secondaryColor = '#AD1C86';

// // Function to convert image to base64
// const getImageBase64 = (imgPath) => {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.crossOrigin = "Anonymous";
//     img.onload = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = img.width;
//       canvas.height = img.height;
//       const ctx = canvas.getContext("2d");
//       ctx.drawImage(img, 0, 0);
//       resolve(canvas.toDataURL("image/jpeg"));
//     };
//     img.onerror = () => {
//       resolve(null);
//     };
//     img.src = imgPath;
//   });
// };

// // ─── Utility Functions ──────────────────────────────────────────────────────

// // Check if exam has started
// const isExamStarted = (startDate, startTime) => {
//   if (!startDate) return false;
  
//   const startDateTime = moment(
//     `${startDate} ${startTime || "00:00"}`,
//     "DD/MM/YYYY HH:mm"
//   );
  
//   return moment().isSameOrAfter(startDateTime);
// };

// // Check if exam has ended
// const isExamEnded = (endDate, endTime) => {
//   if (!endDate) return false;
  
//   const endDateTime = moment(
//     `${endDate} ${endTime || "23:59"}`,
//     "DD/MM/YYYY HH:mm"
//   );
  
//   return moment().isAfter(endDateTime);
// };

// // Check if exam is currently active (started but not ended)
// const isExamActive = (startDate, startTime, endDate, endTime) => {
//   if (!startDate || !endDate) return false;
  
//   const startDateTime = moment(
//     `${startDate} ${startTime || "00:00"}`,
//     "DD/MM/YYYY HH:mm"
//   );
  
//   const endDateTime = moment(
//     `${endDate} ${endTime || "23:59"}`,
//     "DD/MM/YYYY HH:mm"
//   );
  
//   const now = moment();
//   return now.isBetween(startDateTime, endDateTime, null, "[]");
// };

// // Get exam status
// const getExamStatus = (startDate, startTime, endDate, endTime) => {
//   if (isExamEnded(endDate, endTime)) {
//     return { label: "Completed", color: "#757575", icon: <AssignmentIcon sx={{ fontSize: "14px !important" }} /> };
//   } else if (isExamActive(startDate, startTime, endDate, endTime)) {
//     return { label: "Active", color: "#2e7d32", icon: <Star sx={{ fontSize: "14px !important" }} /> };
//   } else if (isExamStarted(startDate, startTime)) {
//     return { label: "Ongoing", color: "#ed6c02", icon: <AccessTimeIcon sx={{ fontSize: "14px !important" }} /> };
//   } else {
//     return { label: "Upcoming", color: "#e65100", icon: <CalendarTodayIcon sx={{ fontSize: "14px !important" }} /> };
//   }
// };

// const formatDate = (dateStr) => {
//   return moment(dateStr, "DD/MM/YYYY").format("MMM D, YYYY");
// };

// const formatTime = (timeStr) => {
//   if (!timeStr) return "—";
//   return moment(timeStr, "HH:mm").format("h:mm A");
// };

// // ─── Professional Admit Card Generator with Logo ────────────────────────────

// // const generateAdmitCard = async (exam, formData, studentData = null) => {
// //   // Get logo as base64
// //   let logoBase64 = "";
// //   try {
// //     const base64 = await getImageBase64(logo);
// //     logoBase64 = base64 || "";
// //   } catch (error) {
// //     console.error("Error loading logo:", error);
// //   }

// //   const logoHTML = logoBase64 
// //     ? `<img src="${logoBase64}" alt="School Logo" style="width: 100%; height: 100%; object-fit: cover;" />`
// //     : `<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-size: 24px; font-weight: bold;">SMS</div>`;

// //   // Generate Roll Number from student ID if available, otherwise from phone number
// //   const getRollNumber = () => {
// //     if (studentData && studentData._id) {
// //       return `SMS-${studentData._id.slice(-6).toUpperCase()}`;
// //     }
// //     // Fallback: generate from phone number and timestamp
// //     const phoneSuffix = formData.phone ? formData.phone.slice(-4) : "0000";
// //     const timestamp = Date.now().toString().slice(-4);
// //     return `SMS-${phoneSuffix}${timestamp}`;
// //   };

// //   // Handle negative marking display
// //   const getNegativeMarkingText = () => {
// //     const negativeMarking = exam.negativeMarking;
// //     if (!negativeMarking || negativeMarking === 0 || negativeMarking === "0" || negativeMarking === null) {
// //       return "No negative marking";
// //     }
// //     return `${negativeMarking} per wrong answer`;
// //   };

// //    // Format date and time for display
// //   const formatDateTime = (dateStr, timeStr) => {
// //     if (!dateStr) return "—";
// //     const formattedDate = moment(dateStr, "DD/MM/YYYY").format("DD MMMM YYYY");
// //     if (!timeStr) return formattedDate;
// //     const formattedTime = moment(timeStr, "HH:mm").format("h:mm A");
// //     return `${formattedDate} at ${formattedTime}`;
// //   };

// //   const admitHtml = `
// // <!DOCTYPE html>
// // <html lang="en">
// // <head>
// //   <meta charset="UTF-8" />
// //   <title>Admit Card - ${exam.name}</title>
// //   <style>
// //     * { margin: 0; padding: 0; box-sizing: border-box; }
// //     body { font-family: 'Segoe UI', Arial, sans-serif; background: #f5f5f5; display: flex; justify-content: center; align-items: center; min-height: 100vh; padding: 20px; }
// //     .card { background: #fff; width: 750px; border: 2px solid ${primaryColor}; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.15); }
// //     .header { background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); color: white; padding: 20px 24px; display: flex; align-items: center; gap: 16px; }
// //     .school-logo { width: 64px; height: 64px; background: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; overflow: hidden; }
// //     .school-logo img { width: 100%; height: 100%; object-fit: cover; }
// //     .header h1 { font-size: 20px; font-weight: 700; margin: 0; }
// //     .header p { font-size: 13px; opacity: 0.85; margin-top: 2px; }
// //     .admit-label { text-align: center; background: #e8eaf6; padding: 10px; font-size: 16px; font-weight: 700; color: ${primaryColor}; letter-spacing: 2px; text-transform: uppercase; border-bottom: 1px solid #c5cae9; }
// //     .body { padding: 24px; }
// //     .section-title { font-size: 12px; font-weight: 700; color: ${secondaryColor}; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; padding-bottom: 4px; border-bottom: 2px solid ${secondaryColor}; }
// //     .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 20px; }
// //     .field label { font-size: 11px; color: #757575; display: block; margin-bottom: 3px; }
// //     .field span { font-size: 14px; font-weight: 600; color: #212121; }
// //     .photo-box { width: 100px; height: 120px; border: 2px dashed ${primaryColor}; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 10px; color: ${primaryColor}; text-align: center; padding: 8px; background: #f5f5f5; }
// //     .instructions { background: #fff8e1; border: 1px solid #ffe082; border-radius: 6px; padding: 14px; margin: 16px 0; }
// //     .instructions h4 { font-size: 12px; color: #e65100; margin-bottom: 8px; font-weight: 700; }
// //     .instructions ol { padding-left: 16px; font-size: 12px; color: #5d4037; }
// //     .instructions li { margin-bottom: 4px; }
// //     .footer { background: #f3f4ff; padding: 16px 24px; display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #c5cae9; }
// //     .signature-box { text-align: center; font-size: 11px; color: #757575; }
// //     .sig-line { width: 120px; border-top: 1.5px solid #333; margin: 0 auto 4px; }
// //     @media print { body { background: white; } .card { box-shadow: none; border: 2px solid ${primaryColor}; } }
// //   </style>
// // </head>
// // <body>
// //   <div class="card">
// //     <div class="header">
// //       <div class="school-logo">
// //         ${logoHTML}
// //       </div>
// //       <div>
// //         <h1>Shree Mangalam School</h1>
// //         <p>RIMC &amp; Sainik School Entrance Preparation</p>
// //       </div>
// //     </div>
// //     <div class="admit-label">Admit Card — Online Examination</div>
// //     <div class="body">
// //       <div style="display:flex; gap:20px; margin-bottom:20px; align-items:flex-start;">
// //         <div style="flex:1;">
// //           <div class="section-title">Student Information</div>
// //           <div class="grid">
// //             <div class="field"><label>Student Name</label><span>${formData.studentName}</span></div>
// //             <div class="field"><label>Date of Birth</label><span>${new Date(formData.dob).toLocaleDateString("en-IN",)}</span></div>
// //             <div class="field"><label>Class</label><span>${formData.class}</span></div>
// //             <div class="field"><label>Parent / Guardian</label><span>${formData.parentName}</span></div>
// //             <div class="field"><label>Phone Number</label><span>${formData.phone}</span></div>
// //             <div class="field"><label>Email</label><span>${formData.email}</span></div>
// //           </div>
// //           <div class="field"><label>Address</label><span>${formData.address}</span></div>
// //         </div>
// //         <div>
// //           <div class="photo-box"><br/>Paste<br/>Photo<br/>Here</div>
// //         </div>
// //       </div>

// //       <div class="section-title">Examination Details</div>
// //       <div class="grid">
// //         <div class="field"><label>Exam Name</label><span>${exam.name}</span></div>
// //         <div class="field"><label>Subject</label><span>${exam.subject}</span></div>
// //         <div class="field"><label>Class</label><span>${exam.class}</span></div>
// //         <div class="field"><label>Duration</label><span>${exam.duration} minutes</span></div>
// //         <div class="field"><label>Total Marks</label><span>${exam.totalMarks}</span></div>
// //         <div class="field"><label>Passing Marks</label><span>${exam.passingMarks}</span></div>
// //         <div class="field"><label>Start Date & Time</label><span>${formatDate(exam.startDate)} ${formatTime(exam.startTime)}</span></div>
// //         <div class="field"><label>End Date & Time</label><span>${formatDate(exam.endDate)} ${formatTime(exam.endTime)}</span></div>
// //         <div class="field"><label>Negative Marking</label><span>${getNegativeMarkingText()}</span></div>
// //         <div class="field"><label>Roll No</label><span>${getRollNumber()}</span></div>
// //       </div>
      
// //       <div class="instructions">
// //         <h4>⚠️ Important Instructions</h4>
// //         <ol>
// //           <li>Carry this admit card on the day of the exam along with a valid ID proof.</li>
// //           <li>Log in using your registered phone number and date of birth.</li>
// //           <li>Ensure stable internet connection before starting the exam.</li>
// //           <li>Do not switch tabs or windows during the exam.</li>
// //           <li>The exam must be completed within the allotted time of <strong>${exam.duration} minutes</strong>.</li>
// //           ${exam.negativeMarking && exam.negativeMarking !== 0 && exam.negativeMarking !== "0" && exam.negativeMarking !== null ? 
// //             `<li>Negative marking of <strong>${exam.negativeMarking}</strong> will apply for wrong answers.</li>` : 
// //             `<li>No negative marking for wrong answers.</li>`}
// //           <li>Read all questions carefully before answering.</li>
// //           <li>Once submitted, answers cannot be changed.</li>
// //         </ol>
// //       </div>
// //     </div>
// //     <div class="footer">
// //       <div class="signature-box">
// //         <div class="sig-line"></div>
// //         Student Signature
// //       </div>
// //       <div style="text-align:center; font-size:11px; color:#757575;">
// //         <div style="font-weight:700; font-size:13px; color:${primaryColor};">Shree Mangalam School</div>
// //         <div>This is a computer-generated admit card</div>
// //         <div>Generated on: ${new Date().toLocaleDateString("en-IN")}</div>
// //       </div>
// //       <div class="signature-box">
// //         <div class="sig-line"></div>
// //         Principal's Signature
// //       </div>
// //     </div>
// //   </div>
// //   <script>window.onload = () => window.print();</script>
// // </body>
// // </html>
// //   `;
// //   const blob = new Blob([admitHtml], { type: "text/html" });
// //   const url = URL.createObjectURL(blob);
// //   const a = document.createElement("a");
// //   a.href = url;
// //   a.download = `AdmitCard_${formData.studentName.replace(/\s+/g, "_")}_${exam.name.replace(/\s+/g, "_")}.html`;
// //   a.click();
// //   URL.revokeObjectURL(url);
// // };

// // ─── Professional Admit Card Generator with Logo ────────────────────────────

// const generateAdmitCard = async (exam, formData, studentData = null) => {
//   // Get logo as base64
//   let logoBase64 = "";
//   try {
//     const base64 = await getImageBase64(logo);
//     logoBase64 = base64 || "";
//   } catch (error) {
//     console.error("Error loading logo:", error);
//   }

//   const logoHTML = logoBase64 
//     ? `<img src="${logoBase64}" alt="School Logo" style="width: 100%; height: 100%; object-fit: cover;" />`
//     : `<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-size: 24px; font-weight: bold;">SMS</div>`;

//   // Generate Roll Number from student ID if available, otherwise from phone number
//   const getRollNumber = () => {
//     if (studentData && studentData._id) {
//       return `SMS-${studentData._id.slice(-6).toUpperCase()}`;
//     }
//     // Fallback: generate from phone number and timestamp
//     const phoneSuffix = formData.phone ? formData.phone.slice(-4) : "0000";
//     const timestamp = Date.now().toString().slice(-4);
//     return `SMS-${phoneSuffix}${timestamp}`;
//   };

//   // Handle negative marking display
//   const getNegativeMarkingText = () => {
//     const negativeMarking = exam.negativeMarking;
//     if (!negativeMarking || negativeMarking === 0 || negativeMarking === "0" || negativeMarking === null) {
//       return "No negative marking";
//     }
//     return `${negativeMarking} per wrong answer`;
//   };

//   // Format date and time for display
//   const formatDateTime = (dateStr, timeStr) => {
//     if (!dateStr) return "—";
//     const formattedDate = moment(dateStr, "DD/MM/YYYY").format("DD MMMM YYYY");
//     if (!timeStr) return formattedDate;
//     const formattedTime = moment(timeStr, "HH:mm").format("h:mm A");
//     return `${formattedDate} at ${formattedTime}`;
//   };

//   const admitHtml = `
// <!DOCTYPE html>
// <html lang="en">
// <head>
//   <meta charset="UTF-8" />
//   <title>Admit Card - ${exam.name}</title>
//   <style>
//     * { margin: 0; padding: 0; box-sizing: border-box; }
//     body { font-family: 'Segoe UI', Arial, sans-serif; background: #f5f5f5; display: flex; justify-content: center; align-items: center; min-height: 100vh; padding: 20px; }
//     .card { background: #fff; width: 750px; border: 2px solid ${primaryColor}; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.15); }
//     .header { background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); color: white; padding: 20px 24px; display: flex; align-items: center; gap: 16px; }
//     .school-logo { width: 64px; height: 64px; background: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; overflow: hidden; }
//     .school-logo img { width: 100%; height: 100%; object-fit: cover; }
//     .header h1 { font-size: 20px; font-weight: 700; margin: 0; }
//     .header p { font-size: 13px; opacity: 0.85; margin-top: 2px; }
//     .admit-label { text-align: center; background: #e8eaf6; padding: 10px; font-size: 16px; font-weight: 700; color: ${primaryColor}; letter-spacing: 2px; text-transform: uppercase; border-bottom: 1px solid #c5cae9; }
//     .body { padding: 24px; }
//     .section-title { font-size: 12px; font-weight: 700; color: ${secondaryColor}; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; padding-bottom: 4px; border-bottom: 2px solid ${secondaryColor}; }
//     .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 20px; }
//     .field label { font-size: 11px; color: #757575; display: block; margin-bottom: 3px; }
//     .field span { font-size: 14px; font-weight: 600; color: #212121; }
//     .photo-box { width: 100px; height: 120px; border: 2px dashed ${primaryColor}; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 10px; color: ${primaryColor}; text-align: center; padding: 8px; background: #f5f5f5; }
//     .instructions { background: #fff8e1; border: 1px solid #ffe082; border-radius: 6px; padding: 14px; margin: 16px 0; }
//     .instructions h4 { font-size: 12px; color: #e65100; margin-bottom: 8px; font-weight: 700; }
//     .instructions ol { padding-left: 16px; font-size: 12px; color: #5d4037; }
//     .instructions li { margin-bottom: 4px; }
//     .time-info { background: #e3f2fd; border: 1px solid #90caf9; border-radius: 6px; padding: 12px; margin: 16px 0; display: flex; justify-content: space-around; }
//     .time-box { text-align: center; }
//     .time-box .label { font-size: 11px; color: #1565c0; font-weight: 600; text-transform: uppercase; }
//     .time-box .value { font-size: 14px; font-weight: 700; color: #0d47a1; margin-top: 4px; }
//     .footer { background: #f3f4ff; padding: 16px 24px; display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #c5cae9; }
//     .signature-box { text-align: center; font-size: 11px; color: #757575; }
//     .sig-line { width: 120px; border-top: 1.5px solid #333; margin: 0 auto 4px; }
//     @media print { body { background: white; } .card { box-shadow: none; border: 2px solid ${primaryColor}; } }
//   </style>
// </head>
// <body>
//   <div class="card">
//     <div class="header">
//       <div class="school-logo">
//         ${logoHTML}
//       </div>
//       <div>
//         <h1>Shree Mangalam School</h1>
//         <p>RIMC &amp; Sainik School Entrance Preparation</p>
//       </div>
//     </div>
//     <div class="admit-label">Admit Card — Online Examination</div>
//     <div class="body">
//       <div style="display:flex; gap:20px; margin-bottom:20px; align-items:flex-start;">
//         <div style="flex:1;">
//           <div class="section-title">Student Information</div>
//           <div class="grid">
//             <div class="field"><label>Student Name</label><span>${formData.studentName}</span></div>
//             <div class="field"><label>Date of Birth</label><span>${new Date(formData.dob).toLocaleDateString("en-IN", { day: 'numeric', month: 'long', year: 'numeric' })}</span></div>
//             <div class="field"><label>Class</label><span>${formData.class}</span></div>
//             <div class="field"><label>Parent / Guardian</label><span>${formData.parentName}</span></div>
//             <div class="field"><label>Phone Number</label><span>${formData.phone}</span></div>
//             <div class="field"><label>Email</label><span>${formData.email}</span></div>
//           </div>
//           <div class="field"><label>Address</label><span>${formData.address}</span></div>
//         </div>
//         <div>
//           <div class="photo-box"><br/>Paste<br/>Photo<br/>Here</div>
//         </div>
//       </div>

//       <div class="section-title">Examination Details</div>
//       <div class="grid">
//         <div class="field"><label>Exam Name</label><span>${exam.name}</span></div>
//         <div class="field"><label>Subject</label><span>${exam.subject}</span></div>
//         <div class="field"><label>Class</label><span>${exam.class}</span></div>
//         <div class="field"><label>Duration</label><span>${exam.duration} minutes</span></div>
//         <div class="field"><label>Total Marks</label><span>${exam.totalMarks}</span></div>
//         <div class="field"><label>Passing Marks</label><span>${exam.passingMarks}</span></div>
//         <div class="field"><label>Negative Marking</label><span>${getNegativeMarkingText()}</span></div>
//         <div class="field"><label>Roll No</label><span>${getRollNumber()}</span></div>
//         <div class="field"><label>Start Date & Time</label><span>${formatDateTime(exam.startDate, exam.startTime)}</span></div>
//         <div class="field"><label>End Date & Time</label><span>${formatDateTime(exam.endDate, exam.endTime)}</span></div>
//       </div>
      
//       <div class="instructions">
//         <h4>⚠️ Important Instructions</h4>
//         <ol>
//           <li>Carry this admit card on the day of the exam along with a valid ID proof.</li>
//           <li>Please report online <strong>15 minutes before</strong> the exam start time.</li>
//           <li>Log in using your registered phone number and date of birth.</li>
//           <li>Ensure stable internet connection before starting the exam.</li>
//           <li>Do not switch tabs or windows during the exam.</li>
//           <li>The exam must be completed within the allotted time of <strong>${exam.duration} minutes</strong>.</li>
//           <li>The exam will automatically end at <strong>${formatDateTime(exam.endDate, exam.endTime)}</strong>.</li>
//           ${exam.negativeMarking && exam.negativeMarking !== 0 && exam.negativeMarking !== "0" && exam.negativeMarking !== null ? 
//             `<li>Negative marking of <strong>${exam.negativeMarking}</strong> will apply for wrong answers.</li>` : 
//             `<li>No negative marking for wrong answers.</li>`}
//           <li>Read all questions carefully before answering.</li>
//           <li>Once submitted, answers cannot be changed.</li>
//         </ol>
//       </div>
//     </div>
//     <div class="footer">
//       <div class="signature-box">
//         <div class="sig-line"></div>
//         Student Signature
//       </div>
//       <div style="text-align:center; font-size:11px; color:#757575;">
//         <div style="font-weight:700; font-size:13px; color:${primaryColor};">Shree Mangalam School</div>
//         <div>This is a computer-generated admit card</div>
//         <div>Generated on: ${new Date().toLocaleDateString("en-IN", { day: 'numeric', month: 'long', year: 'numeric' })} at ${new Date().toLocaleTimeString("en-IN", { hour: '2-digit', minute: '2-digit' })}</div>
//       </div>
//       <div class="signature-box">
//         <div class="sig-line"></div>
//         Principal's Signature
//       </div>
//     </div>
//   </div>
//   <script>window.onload = () => window.print();</script>
// </body>
// </html>
//   `;
//   const blob = new Blob([admitHtml], { type: "text/html" });
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = `AdmitCard_${formData.studentName.replace(/\s+/g, "_")}_${exam.name.replace(/\s+/g, "_")}.html`;
//   a.click();
//   URL.revokeObjectURL(url);
// };

// // ─── Exam Card ───────────────────────────────────────────────────────────────

// const ExamCard = ({ exam, onRegister, onStartExam }) => {
//   const examStatus = getExamStatus(exam.startDate, exam.startTime, exam.endDate, exam.endTime);
//   const isEnded = isExamEnded(exam.endDate, exam.endTime);
//   const questionsCount = Array.isArray(exam.questions) ? exam.questions.length : 0;

//   // Format negative marking for display
//   const getNegativeMarkingDisplay = () => {
//     const nm = exam.negativeMarking;
//     if (!nm || nm === 0 || nm === "0" || nm === null) {
//       return "None";
//     }
//     return `-${nm}`;
//   };

//   return (
//     <Card
//       elevation={0}
//       sx={{
//         border: "1px solid",
//         borderColor: "divider",
//         borderRadius: 3,
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         transition: "box-shadow 0.2s, transform 0.2s",
//         "&:hover": {
//           boxShadow: `0 8px 32px ${primaryColor}1f`,
//           transform: "translateY(-2px)",
//         },
//         opacity: isEnded ? 0.7 : 1,
//       }}
//     >
//       {/* Card Top Accent */}
//       <Box sx={{ height: 6, borderRadius: "12px 12px 0 0", background: examStatus.color }} />

//       <CardContent sx={{ flex: 1, p: 3 }}>
//         <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
//           <Chip
//             label={exam.subject}
//             size="small"
//             sx={{
//               background: "#e8eaf6",
//               color: primaryColor,
//               fontWeight: 600,
//               fontSize: "11px",
//             }}
//           />
//           <Chip
//             label={examStatus.label}
//             size="small"
//             icon={examStatus.icon}
//             sx={{
//               background: examStatus.label === "Completed" ? "#f5f5f5" : examStatus.label === "Active" ? "#e8f5e9" : "#fff8e1",
//               color: examStatus.color,
//               fontWeight: 600,
//               fontSize: "11px",
//             }}
//           />
//         </Stack>

//         <Typography variant="h6" fontWeight={700} color="text.primary" mb={0.5} sx={{ lineHeight: 1.3 }}>
//           {exam.name}
//         </Typography>
//         <Typography variant="body2" color="text.secondary" mb={2}>
//           Class {exam.class}
//         </Typography>

//         <Divider sx={{ mb: 2 }} />

//         <Grid container spacing={1.5} mb={2}>
//           {[
//             { icon: <AssignmentIcon fontSize="small" />, label: "Total Marks", value: exam.totalMarks },
//             { icon: <SchoolIcon fontSize="small" />, label: "Passing Marks", value: exam.passingMarks },
//             { icon: <AccessTimeIcon fontSize="small" />, label: "Duration", value: `${exam.duration} min` },
//             { icon: <CancelIcon fontSize="small" />, label: "Negative Marking", value: getNegativeMarkingDisplay() },
//           ].map((stat) => (
//             <Grid item xs={6} key={stat.label}>
//               <Box
//                 sx={{
//                   background: "#f5f5f5",
//                   borderRadius: 2,
//                   p: 1.25,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                 }}
//               >
//                 <Box sx={{ color: primaryColor }}>{stat.icon}</Box>
//                 <Box>
//                   <Typography variant="caption" color="text.secondary" display="block" lineHeight={1.2}>
//                     {stat.label}
//                   </Typography>
//                   <Typography variant="body2" fontWeight={700}>
//                     {stat.value}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Grid>
//           ))}
//         </Grid>

//         <Stack direction="row" justifyContent="space-between" mb={1}>
//           <Box>
//             <Typography variant="caption" color="text.secondary">Start Date & Time</Typography>
//             <Typography variant="body2" fontWeight={600}>{formatDate(exam.startDate)} {formatTime(exam.startTime)}</Typography>
//           </Box>
//           <Box textAlign="right">
//             <Typography variant="caption" color="text.secondary">End Date & Time</Typography>
//             <Typography variant="body2" fontWeight={600}>{formatDate(exam.endDate)} {formatTime(exam.endTime)}</Typography>
//           </Box>
//         </Stack>

//         {questionsCount > 0 && (
//           <Typography variant="caption" color="text.secondary">
//             {questionsCount} questions
//           </Typography>
//         )}
//       </CardContent>

//       <Box sx={{ p: 2, pt: 0, display: "flex", flexDirection: "column", gap: 1 }}>
//         <Button
//           variant="outlined"
//           fullWidth
//           startIcon={<AssignmentIcon />}
//           onClick={() => onRegister(exam)}
//           disabled={isEnded}
//           sx={{ 
//             borderRadius: 2, 
//             textTransform: "none", 
//             fontWeight: 600, 
//             borderColor: primaryColor, 
//             color: primaryColor, 
//             "&:hover": { borderColor: secondaryColor, background: "#e8eaf6" },
//             "&.Mui-disabled": { borderColor: "#ccc", color: "#999" }
//           }}
//         >
//           {isEnded ? "Registration Closed" : "Register & Get Admit Card"}
//         </Button>

//         {isEnded ? (
//           <Button
//             variant="contained"
//             fullWidth
//             disabled
//             sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, background: "#ccc" }}
//           >
//             Exam Completed
//           </Button>
//         ) : examStatus.label === "Active" ? (
//           <Button
//             variant="contained"
//             fullWidth
//             startIcon={<LoginIcon />}
//             onClick={() => onStartExam(exam)}
//             sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, background: "#2e7d32", "&:hover": { background: "#1b5e20" } }}
//           >
//             Start Exam
//           </Button>
//         ) : (
//           <Button
//             variant="contained"
//             fullWidth
//             disabled
//             sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, background: "#ccc" }}
//           >
//             {examStatus.label === "Upcoming" ? `Starts ${formatDate(exam.startDate)} ${formatTime(exam.startTime)}` : "Exam Not Available"}
//           </Button>
//         )}
//       </Box>
//     </Card>
//   );
// };

// // ─── Registration Modal ──────────────────────────────────────────────────────

// const RegistrationModal = ({ open, exam, onClose }) => {
//   const [formData, setFormData] = useState({
//     studentName: "",
//     dob: "",
//     class: "",
//     parentName: "",
//     phone: "",
//     email: "",
//     address: "",
//   });
//   const [errors, setErrors] = useState({});
//   const [submitted, setSubmitted] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [apiError, setApiError] = useState("");
//   const [registeredStudent, setRegisteredStudent] = useState(null);

//   const handleChange = (e) => {
//     setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));
//     setErrors((p) => ({ ...p, [e.target.name]: "" }));
//     setApiError("");
//   };

//   const validate = () => {
//     const e = {};
//     if (!formData.studentName.trim()) e.studentName = "Student name is required";
//     if (!formData.dob) e.dob = "Date of birth is required";
//     if (!formData.class.trim()) e.class = "Class is required";
//     if (!formData.parentName.trim()) e.parentName = "Parent name is required";
//     if (!/^\d{10}$/.test(formData.phone)) e.phone = "Enter a valid 10-digit phone number";
//     if (!/\S+@\S+\.\S+/.test(formData.email)) e.email = "Enter a valid email";
//     if (!formData.address.trim()) e.address = "Address is required";
//     return e;
//   };

//   const handleSubmit = async () => {
//     const e = validate();
//     if (Object.keys(e).length) { setErrors(e); return; }

//     setLoading(true);
//     setApiError("");
//     try {
//       const payload = {
//         studentName: formData.studentName,
//         dob: formData.dob,
//         class: formData.class,
//         parentName: formData.parentName,
//         phone: formData.phone,
//         email: formData.email,
//         address: formData.address,
//         examIds: [exam._id],
//       };
//       const response = await axios.post("/api/v1/student/register", payload);
//       if (response.data.success || response.status === 200 || response.status === 201) {
//         // Store the registered student data from response
//         const studentData = response.data.data || response.data.student;
//         setRegisteredStudent(studentData);
//         setSubmitted(true);
//       } else {
//         setApiError(response.data.message || "Registration failed. Please try again.");
//       }
//     } catch (err) {
//       setApiError(
//         err?.response?.data?.message || "Registration failed. Please try again."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownload = async () => {
//     // Pass the registered student data to generate admit card
//     await generateAdmitCard(exam, formData, registeredStudent);
//   };

//   const handleClose = () => {
//     setFormData({ studentName: "", dob: "", class: "", parentName: "", phone: "", email: "", address: "" });
//     setErrors({});
//     setSubmitted(false);
//     setApiError("");
//     setLoading(false);
//     setRegisteredStudent(null);
//     onClose();
//   };

//   return (
//     <Modal open={open} onClose={handleClose}>
//       <Box
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: { xs: "95vw", sm: 560 },
//           maxHeight: "90vh",
//           overflowY: "auto",
//           bgcolor: "background.paper",
//           borderRadius: 3,
//           boxShadow: 24,
//           outline: "none",
//         }}
//       >
//         <Box sx={{ p: 3, pb: 2, borderBottom: "1px solid", borderColor: "divider", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//           <Box>
//             <Typography variant="h6" fontWeight={700} sx={{ color: primaryColor }}>Exam Registration</Typography>
//             <Typography variant="body2" color="text.secondary">{exam?.name} — {exam?.subject}</Typography>
//           </Box>
//           <IconButton onClick={handleClose} size="small"><CloseIcon fontSize="small" /></IconButton>
//         </Box>

//         <Box sx={{ p: 3 }}>
//           {!submitted ? (
//             <>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Student Name"
//                     name="studentName"
//                     value={formData.studentName}
//                     onChange={handleChange}
//                     fullWidth
//                     size="small"
//                     error={!!errors.studentName}
//                     helperText={errors.studentName}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Date of Birth"
//                     name="dob"
//                     type="date"
//                     value={formData.dob}
//                     onChange={handleChange}
//                     fullWidth
//                     size="small"
//                     InputLabelProps={{ shrink: true }}
//                     error={!!errors.dob}
//                     helperText={errors.dob}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Class"
//                     name="class"
//                     value={formData.class}
//                     onChange={handleChange}
//                     fullWidth
//                     size="small"
//                     placeholder="e.g. 10th"
//                     error={!!errors.class}
//                     helperText={errors.class}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Parent / Guardian Name"
//                     name="parentName"
//                     value={formData.parentName}
//                     onChange={handleChange}
//                     fullWidth
//                     size="small"
//                     error={!!errors.parentName}
//                     helperText={errors.parentName}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Phone Number"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     fullWidth
//                     size="small"
//                     inputProps={{ maxLength: 10 }}
//                     error={!!errors.phone}
//                     helperText={errors.phone}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     label="Email Address"
//                     name="email"
//                     type="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     fullWidth
//                     size="small"
//                     error={!!errors.email}
//                     helperText={errors.email}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField
//                     label="Address"
//                     name="address"
//                     value={formData.address}
//                     onChange={handleChange}
//                     fullWidth
//                     size="small"
//                     multiline
//                     rows={2}
//                     error={!!errors.address}
//                     helperText={errors.address}
//                   />
//                 </Grid>
//               </Grid>

//               <Button
//                 variant="contained"
//                 fullWidth
//                 sx={{ mt: 3, borderRadius: 2, textTransform: "none", fontWeight: 600, py: 1.2, background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`, "&:hover": { background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)` } }}
//                 onClick={handleSubmit}
//                 disabled={loading}
//                 startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
//               >
//                 {loading ? "Submitting..." : "Submit Registration"}
//               </Button>

//               {apiError && <Alert severity="error" sx={{ mt: 2 }}>{apiError}</Alert>}
//             </>
//           ) : (
//             <Box textAlign="center" py={2}>
//               <Box
//                 sx={{
//                   width: 72, height: 72, borderRadius: "50%",
//                   background: "#e8f5e9", display: "flex",
//                   alignItems: "center", justifyContent: "center", mx: "auto", mb: 2,
//                 }}
//               >
//                 <SchoolIcon sx={{ fontSize: 36, color: "#2e7d32" }} />
//               </Box>
//               <Typography variant="h6" fontWeight={700} mb={1}>Registration Successful!</Typography>
//               <Typography variant="body2" color="text.secondary" mb={3}>
//                 Your admit card for <strong>{exam?.name}</strong> is ready. Download it and keep it safe for exam day.
//               </Typography>
//               <Alert severity="info" sx={{ mb: 3, textAlign: "left" }}>
//                 <strong>Login Credentials for Exam Day:</strong><br />
//                 Phone: <strong>{formData.phone}</strong> &nbsp;|&nbsp; DOB: <strong>{formData.dob}</strong>
//               </Alert>
//               <Button
//                 variant="contained"
//                 startIcon={<DownloadIcon />}
//                 onClick={handleDownload}
//                 fullWidth
//                 sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, py: 1.2, background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`, "&:hover": { background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)` }, mb: 1.5 }}
//               >
//                 Download Admit Card
//               </Button>
//               <Button variant="outlined" fullWidth sx={{ borderRadius: 2, textTransform: "none", borderColor: primaryColor, color: primaryColor }} onClick={handleClose}>
//                 Close
//               </Button>
//             </Box>
//           )}
//         </Box>
//       </Box>
//     </Modal>
//   );
// };

// // ─── Exam Login Modal ────────────────────────────────────────────────────────

// const ExamLoginModal = ({ open, exam, onClose }) => {
//   const navigate = useNavigate();
//   const [credentials, setCredentials] = useState({ phone: "", dob: "" });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [apiError, setApiError] = useState("");

//   const handleChange = (e) => {
//     setCredentials((p) => ({ ...p, [e.target.name]: e.target.value }));
//     setErrors((p) => ({ ...p, [e.target.name]: "" }));
//     setApiError("");
//   };

//   const validate = () => {
//     const e = {};
//     if (!/^\d{10}$/.test(credentials.phone)) e.phone = "Enter a valid 10-digit phone number";
//     if (!credentials.dob) e.dob = "Date of birth is required";
//     return e;
//   };

//   const handleVerify = async () => {
//     const e = validate();
//     if (Object.keys(e).length) { setErrors(e); return; }

//     setLoading(true);
//     setApiError("");
//     try {
//       const response = await axios.post(`/api/v1/student/verify`, {
//         examId: exam._id,
//         phone: credentials.phone,
//         dob: credentials.dob,
//       });

//       if (response.data.success) {
//         const student = response.data.student || response.data.data;
//         localStorage.setItem(
//           "verifiedStudent",
//           JSON.stringify(student)
//         );
//         navigate(`/write-exam/${exam._id}`, {
//           state: { studentData: student, exam },
//         });
//       } else {
//         setApiError(response.data.message || "Verification failed. Please check your credentials.");
//       }
//     } catch (err) {
//       setApiError(
//         err?.response?.data?.message ||
//         "Verification failed. Please check your phone number and date of birth."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClose = () => {
//     setCredentials({ phone: "", dob: "" });
//     setErrors({});
//     setApiError("");
//     onClose();
//   };

//   return (
//     <Modal open={open} onClose={handleClose}>
//       <Box
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: { xs: "95vw", sm: 420 },
//           bgcolor: "background.paper",
//           borderRadius: 3,
//           boxShadow: 24,
//           outline: "none",
//         }}
//       >
//         <Box sx={{ p: 3, pb: 2, borderBottom: "1px solid", borderColor: "divider", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//           <Box>
//             <Typography variant="h6" fontWeight={700} sx={{ color: primaryColor }}>Student Verification</Typography>
//             <Typography variant="body2" color="text.secondary">{exam?.name}</Typography>
//           </Box>
//           <IconButton onClick={handleClose} size="small"><CloseIcon fontSize="small" /></IconButton>
//         </Box>

//         <Box sx={{ p: 3 }}>
//           <Alert severity="info" sx={{ mb: 3 }}>
//             Enter the phone number and date of birth you used during registration.
//           </Alert>

//           {apiError && <Alert severity="error" sx={{ mb: 2 }}>{apiError}</Alert>}

//           <Stack spacing={2}>
//             <TextField
//               label="Registered Phone Number"
//               name="phone"
//               value={credentials.phone}
//               onChange={handleChange}
//               fullWidth
//               inputProps={{ maxLength: 10 }}
//               error={!!errors.phone}
//               helperText={errors.phone}
//               placeholder="10-digit mobile number"
//             />
//             <TextField
//               label="Date of Birth"
//               name="dob"
//               type="date"
//               value={credentials.dob}
//               onChange={handleChange}
//               fullWidth
//               InputLabelProps={{ shrink: true }}
//               error={!!errors.dob}
//               helperText={errors.dob}
//             />
//           </Stack>

//           <Button
//             variant="contained"
//             fullWidth
//             sx={{ mt: 3, borderRadius: 2, textTransform: "none", fontWeight: 600, py: 1.4, background: "#2e7d32", "&:hover": { background: "#1b5e20" } }}
//             onClick={handleVerify}
//             disabled={loading}
//             startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <LoginIcon />}
//           >
//             {loading ? "Verifying..." : "Verify & Start Exam"}
//           </Button>
//         </Box>
//       </Box>
//     </Modal>
//   );
// };

// // ─── Main Page ───────────────────────────────────────────────────────────────

// const OnlineExams = () => {
//   const [exams, setExams] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [regOpen, setRegOpen] = useState(false);
//   const [selectedExam, setSelectedExam] = useState(null);

//   const [loginOpen, setLoginOpen] = useState(false);
//   const [loginExam, setLoginExam] = useState(null);

//   const getAllExams = async () => {
//     try {
//       const response = await axios.get(`/api/v1/exam/active`);
//       setExams(response.data.data || []);
//     } catch (error) {
//       console.error("Failed to fetch exams:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getAllExams();
//   }, []);

//   const handleRegister = (exam) => {
//     setSelectedExam(exam);
//     setRegOpen(true);
//   };

//   const handleStartExam = (exam) => {
//     setLoginExam(exam);
//     setLoginOpen(true);
//   };

//   return (
//     <>
//       <Navbar />
//       <PageTitle
//         title="Online Exams - Shree Mangalam School"
//         description="Take your online exams at Shree Mangalam School. Convenient and accessible exam platform for all students."
//         url="/online-exams"
//         keywords="online exams, Shree Mangalam exams, RIMC exams, sainik school exams, secure exam portal"
//       />
//       <Header image={OnlineExamsBanner} alt={"Shree Mangalam School"} />

//       <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, md: 4 }, py: 5 }}>
//         <Box mb={4}>
//           <Typography variant="h4" fontWeight={700} color="text.primary" sx={{ color: primaryColor }}>
//             Available Exams
//           </Typography>
//           <Typography variant="body1" color="text.secondary" mt={0.5}>
//             Register for an exam and download your admit card. You can start the exam on or after the start date.
//           </Typography>
//         </Box>

//         {loading ? (
//           <Box display="flex" justifyContent="center" py={8}>
//             <CircularProgress sx={{ color: primaryColor }} />
//           </Box>
//         ) : exams.length === 0 ? (
//           <Box textAlign="center" py={8}>
//             <AssignmentIcon sx={{ fontSize: 60, color: "text.disabled" }} />
//             <Typography variant="h6" color="text.secondary" mt={2}>No active exams found.</Typography>
//           </Box>
//         ) : (
//           <Grid container spacing={3}>
//             {exams.map((exam) => (
//               <Grid item xs={12} sm={6} md={4} key={exam._id}>
//                 <ExamCard
//                   exam={exam}
//                   onRegister={handleRegister}
//                   onStartExam={handleStartExam}
//                 />
//               </Grid>
//             ))}
//           </Grid>
//         )}
//       </Box>

//       {selectedExam && (
//         <RegistrationModal
//           open={regOpen}
//           exam={selectedExam}
//           onClose={() => { setRegOpen(false); setSelectedExam(null); }}
//         />
//       )}

//       {loginExam && (
//         <ExamLoginModal
//           open={loginOpen}
//           exam={loginExam}
//           onClose={() => { setLoginOpen(false); setLoginExam(null); }}
//         />
//       )}
//       <Footer />
//     </>
//   );
// };

// export default OnlineExams;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment"
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import PageTitle from "../Components/PageTitle";
import Header from "../Components/Header";
import OnlineExamsBanner from "../assets/OnlineExams.png";
import axios from "../axiosInstance";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  Modal,
  TextField,
  Divider,
  Stack,
  IconButton,
  Alert,
  CircularProgress,
} from "@mui/material";
import {
  Close as CloseIcon,
  Download as DownloadIcon,
  School as SchoolIcon,
  AccessTime as AccessTimeIcon,
  CalendarToday as CalendarTodayIcon,
  Assignment as AssignmentIcon,
  Star as StarIcon,
  Cancel as CancelIcon,
  Login as LoginIcon,
  Star,
  Phone as PhoneIcon,
  Cake as CakeIcon,
  Person as PersonIcon,
  ParentalHelp as ParentIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
} from "@mui/icons-material";
import logo from "../assets/mainLogo.jpg";

// Brand Colors
const primaryColor = '#065A79';
const secondaryColor = '#AD1C86';

// Function to convert image to base64
const getImageBase64 = (imgPath) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/jpeg"));
    };
    img.onerror = () => {
      resolve(null);
    };
    img.src = imgPath;
  });
};

// ─── Utility Functions ──────────────────────────────────────────────────────

// Age validation function (7 to 15 years)
const isValidAge = (dob) => {
  if (!dob) return false;
  const birthDate = new Date(dob);
  const today = new Date();
  
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age >= 7 && age <= 15;
};

// Get age from DOB
const calculateAge = (dob) => {
  if (!dob) return 0;
  const birthDate = new Date(dob);
  const today = new Date();
  
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
};

// Check if exam has started
const isExamStarted = (startDate, startTime) => {
  if (!startDate) return false;
  
  const startDateTime = moment(
    `${startDate} ${startTime || "00:00"}`,
    "DD/MM/YYYY HH:mm"
  );
  
  return moment().isSameOrAfter(startDateTime);
};

// Check if exam has ended
const isExamEnded = (endDate, endTime) => {
  if (!endDate) return false;
  
  const endDateTime = moment(
    `${endDate} ${endTime || "23:59"}`,
    "DD/MM/YYYY HH:mm"
  );
  
  return moment().isAfter(endDateTime);
};

// Check if exam is currently active (started but not ended)
const isExamActive = (startDate, startTime, endDate, endTime) => {
  if (!startDate || !endDate) return false;
  
  const startDateTime = moment(
    `${startDate} ${startTime || "00:00"}`,
    "DD/MM/YYYY HH:mm"
  );
  
  const endDateTime = moment(
    `${endDate} ${endTime || "23:59"}`,
    "DD/MM/YYYY HH:mm"
  );
  
  const now = moment();
  return now.isBetween(startDateTime, endDateTime, null, "[]");
};

// Get exam status
const getExamStatus = (startDate, startTime, endDate, endTime) => {
  if (isExamEnded(endDate, endTime)) {
    return { label: "Completed", color: "#757575", icon: <AssignmentIcon sx={{ fontSize: "14px !important" }} /> };
  } else if (isExamActive(startDate, startTime, endDate, endTime)) {
    return { label: "Active", color: "#2e7d32", icon: <Star sx={{ fontSize: "14px !important" }} /> };
  } else if (isExamStarted(startDate, startTime)) {
    return { label: "Ongoing", color: "#ed6c02", icon: <AccessTimeIcon sx={{ fontSize: "14px !important" }} /> };
  } else {
    return { label: "Upcoming", color: "#e65100", icon: <CalendarTodayIcon sx={{ fontSize: "14px !important" }} /> };
  }
};

const formatDate = (dateStr) => {
  return moment(dateStr, "DD/MM/YYYY").format("MMM D, YYYY");
};

const formatTime = (timeStr) => {
  if (!timeStr) return "—";
  return moment(timeStr, "HH:mm").format("h:mm A");
};

// ─── Professional Admit Card Generator with Logo ────────────────────────────

const generateAdmitCard = async (exam, formData, studentData = null) => {
  // Get logo as base64
  let logoBase64 = "";
  try {
    const base64 = await getImageBase64(logo);
    logoBase64 = base64 || "";
  } catch (error) {
    console.error("Error loading logo:", error);
  }

  const logoHTML = logoBase64 
    ? `<img src="${logoBase64}" alt="School Logo" style="width: 100%; height: 100%; object-fit: cover;" />`
    : `<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-size: 24px; font-weight: bold;">SMS</div>`;

  // Generate Roll Number from student ID if available, otherwise from phone number
  const getRollNumber = () => {
    if (studentData && studentData._id) {
      return `SMS-${studentData._id.slice(-6).toUpperCase()}`;
    }
    // Fallback: generate from phone number and timestamp
    const phoneSuffix = formData.phone ? formData.phone.slice(-4) : "0000";
    const timestamp = Date.now().toString().slice(-4);
    return `SMS-${phoneSuffix}${timestamp}`;
  };

  // Handle negative marking display
  const getNegativeMarkingText = () => {
    const negativeMarking = exam.negativeMarking;
    if (!negativeMarking || negativeMarking === 0 || negativeMarking === "0" || negativeMarking === null) {
      return "No negative marking";
    }
    return `${negativeMarking} per wrong answer`;
  };

  // Format date and time for display
  const formatDateTime = (dateStr, timeStr) => {
    if (!dateStr) return "—";
    const formattedDate = moment(dateStr, "DD/MM/YYYY").format("DD MMMM YYYY");
    if (!timeStr) return formattedDate;
    const formattedTime = moment(timeStr, "HH:mm").format("h:mm A");
    return `${formattedDate} at ${formattedTime}`;
  };

  const admitHtml = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>Admit Card - ${exam.name}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Segoe UI', Arial, sans-serif; background: #f5f5f5; display: flex; justify-content: center; align-items: center; min-height: 100vh; padding: 20px; }
    .card { background: #fff; width: 750px; border: 2px solid ${primaryColor}; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.15); }
    .header { background: linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%); color: white; padding: 20px 24px; display: flex; align-items: center; gap: 16px; }
    .school-logo { width: 64px; height: 64px; background: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; overflow: hidden; }
    .school-logo img { width: 100%; height: 100%; object-fit: cover; }
    .header h1 { font-size: 20px; font-weight: 700; margin: 0; }
    .header p { font-size: 13px; opacity: 0.85; margin-top: 2px; }
    .admit-label { text-align: center; background: #e8eaf6; padding: 10px; font-size: 16px; font-weight: 700; color: ${primaryColor}; letter-spacing: 2px; text-transform: uppercase; border-bottom: 1px solid #c5cae9; }
    .body { padding: 24px; }
    .section-title { font-size: 12px; font-weight: 700; color: ${secondaryColor}; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; padding-bottom: 4px; border-bottom: 2px solid ${secondaryColor}; }
    .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 20px; }
    .field label { font-size: 11px; color: #757575; display: block; margin-bottom: 3px; }
    .field span { font-size: 14px; font-weight: 600; color: #212121; }
    .photo-box { width: 100px; height: 120px; border: 2px dashed ${primaryColor}; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 10px; color: ${primaryColor}; text-align: center; padding: 8px; background: #f5f5f5; }
    .instructions { background: #fff8e1; border: 1px solid #ffe082; border-radius: 6px; padding: 14px; margin: 16px 0; }
    .instructions h4 { font-size: 12px; color: #e65100; margin-bottom: 8px; font-weight: 700; }
    .instructions ol { padding-left: 16px; font-size: 12px; color: #5d4037; }
    .instructions li { margin-bottom: 4px; }
    .time-info { background: #e3f2fd; border: 1px solid #90caf9; border-radius: 6px; padding: 12px; margin: 16px 0; display: flex; justify-content: space-around; }
    .time-box { text-align: center; }
    .time-box .label { font-size: 11px; color: #1565c0; font-weight: 600; text-transform: uppercase; }
    .time-box .value { font-size: 14px; font-weight: 700; color: #0d47a1; margin-top: 4px; }
    .footer { background: #f3f4ff; padding: 16px 24px; display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #c5cae9; }
    .signature-box { text-align: center; font-size: 11px; color: #757575; }
    .sig-line { width: 120px; border-top: 1.5px solid #333; margin: 0 auto 4px; }
    @media print { body { background: white; } .card { box-shadow: none; border: 2px solid ${primaryColor}; } }
  </style>
</head>
<body>
  <div class="card">
    <div class="header">
      <div class="school-logo">
        ${logoHTML}
      </div>
      <div>
        <h1>Shree Mangalam School</h1>
        <p>RIMC &amp; Sainik School Entrance Preparation</p>
      </div>
    </div>
    <div class="admit-label">Admit Card — Online Examination</div>
    <div class="body">
      <div style="display:flex; gap:20px; margin-bottom:20px; align-items:flex-start;">
        <div style="flex:1;">
          <div class="section-title">Student Information</div>
          <div class="grid">
            <div class="field"><label>Student Name</label><span>${formData.studentName}</span></div>
            <div class="field"><label>Date of Birth</label><span>${new Date(formData.dob).toLocaleDateString("en-IN", { day: 'numeric', month: 'long', year: 'numeric' })}</span></div>
            <div class="field"><label>Class</label><span>${formData.class}</span></div>
            <div class="field"><label>Parent / Guardian</label><span>${formData.parentName}</span></div>
            <div class="field"><label>Phone Number</label><span>${formData.phone}</span></div>
            <div class="field"><label>Email</label><span>${formData.email}</span></div>
          </div>
          <div class="field"><label>Address</label><span>${formData.address}</span></div>
        </div>
        <div>
          <div class="photo-box"><br/>Paste<br/>Photo<br/>Here</div>
        </div>
      </div>

      <div class="section-title">Examination Details</div>
      <div class="grid">
        <div class="field"><label>Exam Name</label><span>${exam.name}</span></div>
        <div class="field"><label>Subject</label><span>${exam.subject}</span></div>
        <div class="field"><label>Class</label><span>${exam.class}</span></div>
        <div class="field"><label>Duration</label><span>${exam.duration} minutes</span></div>
        <div class="field"><label>Total Marks</label><span>${exam.totalMarks}</span></div>
        <div class="field"><label>Passing Marks</label><span>${exam.passingMarks}</span></div>
        <div class="field"><label>Negative Marking</label><span>${getNegativeMarkingText()}</span></div>
        <div class="field"><label>Roll No</label><span>${getRollNumber()}</span></div>
        <div class="field"><label>Start Date & Time</label><span>${formatDateTime(exam.startDate, exam.startTime)}</span></div>
        <div class="field"><label>End Date & Time</label><span>${formatDateTime(exam.endDate, exam.endTime)}</span></div>
      </div>
      
      <div class="instructions">
        <h4>⚠️ Important Instructions</h4>
        <ol>
          <li>Carry this admit card on the day of the exam along with a valid ID proof.</li>
          <li>Please report online <strong>15 minutes before</strong> the exam start time.</li>
          <li>Log in using your registered phone number and date of birth.</li>
          <li>Ensure stable internet connection before starting the exam.</li>
          <li>Do not switch tabs or windows during the exam.</li>
          <li>The exam must be completed within the allotted time of <strong>${exam.duration} minutes</strong>.</li>
          <li>The exam will automatically end at <strong>${formatDateTime(exam.endDate, exam.endTime)}</strong>.</li>
          ${exam.negativeMarking && exam.negativeMarking !== 0 && exam.negativeMarking !== "0" && exam.negativeMarking !== null ? 
            `<li>Negative marking of <strong>${exam.negativeMarking}</strong> will apply for wrong answers.</li>` : 
            `<li>No negative marking for wrong answers.</li>`}
          <li>Read all questions carefully before answering.</li>
          <li>Once submitted, answers cannot be changed.</li>
        </ol>
      </div>
    </div>
    <div class="footer">
      <div class="signature-box">
        <div class="sig-line"></div>
        Student Signature
      </div>
      <div style="text-align:center; font-size:11px; color:#757575;">
        <div style="font-weight:700; font-size:13px; color:${primaryColor};">Shree Mangalam School</div>
        <div>This is a computer-generated admit card</div>
        <div>Generated on: ${new Date().toLocaleDateString("en-IN", { day: 'numeric', month: 'long', year: 'numeric' })} at ${new Date().toLocaleTimeString("en-IN", { hour: '2-digit', minute: '2-digit' })}</div>
      </div>
      <div class="signature-box">
        <div class="sig-line"></div>
        Principal's Signature
      </div>
    </div>
  </div>
  <script>window.onload = () => window.print();</script>
</body>
</html>
  `;
  const blob = new Blob([admitHtml], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `AdmitCard_${formData.studentName.replace(/\s+/g, "_")}_${exam.name.replace(/\s+/g, "_")}.html`;
  a.click();
  URL.revokeObjectURL(url);
};

// ─── Exam Card ───────────────────────────────────────────────────────────────

const ExamCard = ({ exam, onRegister, onStartExam }) => {
  const examStatus = getExamStatus(exam.startDate, exam.startTime, exam.endDate, exam.endTime);
  const isEnded = isExamEnded(exam.endDate, exam.endTime);
  const questionsCount = Array.isArray(exam.questions) ? exam.questions.length : 0;

  // Format negative marking for display
  const getNegativeMarkingDisplay = () => {
    const nm = exam.negativeMarking;
    if (!nm || nm === 0 || nm === "0" || nm === null) {
      return "None";
    }
    return `-${nm}`;
  };

  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "box-shadow 0.2s, transform 0.2s",
        "&:hover": {
          boxShadow: `0 8px 32px ${primaryColor}1f`,
          transform: "translateY(-2px)",
        },
        opacity: isEnded ? 0.7 : 1,
      }}
    >
      {/* Card Top Accent */}
      <Box sx={{ height: 6, borderRadius: "12px 12px 0 0", background: examStatus.color }} />

      <CardContent sx={{ flex: 1, p: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
          <Chip
            label={exam.subject}
            size="small"
            sx={{
              background: "#e8eaf6",
              color: primaryColor,
              fontWeight: 600,
              fontSize: "11px",
            }}
          />
          <Chip
            label={examStatus.label}
            size="small"
            icon={examStatus.icon}
            sx={{
              background: examStatus.label === "Completed" ? "#f5f5f5" : examStatus.label === "Active" ? "#e8f5e9" : "#fff8e1",
              color: examStatus.color,
              fontWeight: 600,
              fontSize: "11px",
            }}
          />
        </Stack>

        <Typography variant="h6" fontWeight={700} color="text.primary" mb={0.5} sx={{ lineHeight: 1.3 }}>
          {exam.name}
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Class {exam.class}
        </Typography>

        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={1.5} mb={2}>
          {[
            { icon: <AssignmentIcon fontSize="small" />, label: "Total Marks", value: exam.totalMarks },
            { icon: <SchoolIcon fontSize="small" />, label: "Passing Marks", value: exam.passingMarks },
            { icon: <AccessTimeIcon fontSize="small" />, label: "Duration", value: `${exam.duration} min` },
            { icon: <CancelIcon fontSize="small" />, label: "Negative Marking", value: getNegativeMarkingDisplay() },
          ].map((stat) => (
            <Grid item xs={6} key={stat.label}>
              <Box
                sx={{
                  background: "#f5f5f5",
                  borderRadius: 2,
                  p: 1.25,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box sx={{ color: primaryColor }}>{stat.icon}</Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" display="block" lineHeight={1.2}>
                    {stat.label}
                  </Typography>
                  <Typography variant="body2" fontWeight={700}>
                    {stat.value}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Stack direction="row" justifyContent="space-between" mb={1}>
          <Box>
            <Typography variant="caption" color="text.secondary">Start Date & Time</Typography>
            <Typography variant="body2" fontWeight={600}>{formatDate(exam.startDate)} {formatTime(exam.startTime)}</Typography>
          </Box>
          <Box textAlign="right">
            <Typography variant="caption" color="text.secondary">End Date & Time</Typography>
            <Typography variant="body2" fontWeight={600}>{formatDate(exam.endDate)} {formatTime(exam.endTime)}</Typography>
          </Box>
        </Stack>

        {questionsCount > 0 && (
          <Typography variant="caption" color="text.secondary">
            {questionsCount} questions
          </Typography>
        )}
      </CardContent>

      <Box sx={{ p: 2, pt: 0, display: "flex", flexDirection: "column", gap: 1 }}>
        <Button
          variant="outlined"
          fullWidth
          startIcon={<AssignmentIcon />}
          onClick={() => onRegister(exam)}
          disabled={isEnded}
          sx={{ 
            borderRadius: 2, 
            textTransform: "none", 
            fontWeight: 600, 
            borderColor: primaryColor, 
            color: primaryColor, 
            "&:hover": { borderColor: secondaryColor, background: "#e8eaf6" },
            "&.Mui-disabled": { borderColor: "#ccc", color: "#999" }
          }}
        >
          {isEnded ? "Registration Closed" : "Register & Get Admit Card"}
        </Button>

        {isEnded ? (
          <Button
            variant="contained"
            fullWidth
            disabled
            sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, background: "#ccc" }}
          >
            Exam Completed
          </Button>
        ) : examStatus.label === "Active" ? (
          <Button
            variant="contained"
            fullWidth
            startIcon={<LoginIcon />}
            onClick={() => onStartExam(exam)}
            sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, background: "#2e7d32", "&:hover": { background: "#1b5e20" } }}
          >
            Start Exam
          </Button>
        ) : (
          <Button
            variant="contained"
            fullWidth
            disabled
            sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, background: "#ccc" }}
          >
            {examStatus.label === "Upcoming" ? `Starts ${formatDate(exam.startDate)} ${formatTime(exam.startTime)}` : "Exam Not Available"}
          </Button>
        )}
      </Box>
    </Card>
  );
};

// ─── Registration Modal ──────────────────────────────────────────────────────

const RegistrationModal = ({ open, exam, onClose }) => {
  const [formData, setFormData] = useState({
    studentName: "",
    dob: "",
    class: "",
    parentName: "",
    phone: "",
    email: "",
    address: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [registeredStudent, setRegisteredStudent] = useState(null);

  const handleChange = (e) => {
    setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));
    setErrors((p) => ({ ...p, [e.target.name]: "" }));
    setApiError("");
  };

  const validate = () => {
    const e = {};
    if (!formData.studentName.trim()) e.studentName = "Student name is required";
    if (!formData.dob) {
      e.dob = "Date of birth is required";
    } else {
      // Age validation
      if (!isValidAge(formData.dob)) {
        const age = calculateAge(formData.dob);
        e.dob = `Student age must be between 7 and 15 years. Current age: ${age} years`;
      }
    }
    if (!formData.class.trim()) e.class = "Class is required";
    if (!formData.parentName.trim()) e.parentName = "Parent name is required";
    if (!/^\d{10}$/.test(formData.phone)) e.phone = "Enter a valid 10-digit phone number";
    if (!/\S+@\S+\.\S+/.test(formData.email)) e.email = "Enter a valid email";
    if (!formData.address.trim()) e.address = "Address is required";
    return e;
  };

  // Get age hint display
  const getAgeHint = () => {
    if (formData.dob) {
      const age = calculateAge(formData.dob);
      if (age >= 7 && age <= 15) {
        return (
          <Typography variant="caption" sx={{ color: "#2e7d32", mt: 0.5, display: "block" }}>
            ✓ Age: {age} years (Eligible for exam)
          </Typography>
        );
      } else if (age > 0) {
        return (
          <Typography variant="caption" sx={{ color: "#d32f2f", mt: 0.5, display: "block" }}>
            ✗ Age: {age} years (Must be between 7-15 years)
          </Typography>
        );
      }
    }
    return (
      <Typography variant="caption" sx={{ color: "#757575", mt: 0.5, display: "block" }}>
        Age must be between 7 and 15 years
      </Typography>
    );
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }

    setLoading(true);
    setApiError("");
    try {
      const payload = {
        studentName: formData.studentName,
        dob: formData.dob,
        class: formData.class,
        parentName: formData.parentName,
        phone: formData.phone,
        email: formData.email,
        address: formData.address,
        examIds: [exam._id],
      };
      const response = await axios.post("/api/v1/student/register", payload);
      if (response.data.success || response.status === 200 || response.status === 201) {
        // Store the registered student data from response
        const studentData = response.data.data || response.data.student;
        setRegisteredStudent(studentData);
        setSubmitted(true);
      } else {
        setApiError(response.data.message || "Registration failed. Please try again.");
      }
    } catch (err) {
      setApiError(
        err?.response?.data?.message || "Registration failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    // Pass the registered student data to generate admit card
    await generateAdmitCard(exam, formData, registeredStudent);
  };

  const handleClose = () => {
    setFormData({ studentName: "", dob: "", class: "", parentName: "", phone: "", email: "", address: "" });
    setErrors({});
    setSubmitted(false);
    setApiError("");
    setLoading(false);
    setRegisteredStudent(null);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "95vw", sm: 560 },
          maxHeight: "90vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          outline: "none",
        }}
      >
        <Box sx={{ p: 3, pb: 2, borderBottom: "1px solid", borderColor: "divider", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <Box>
            <Typography variant="h6" fontWeight={700} sx={{ color: primaryColor }}>Exam Registration</Typography>
            <Typography variant="body2" color="text.secondary">{exam?.name} — {exam?.subject}</Typography>
          </Box>
          <IconButton onClick={handleClose} size="small"><CloseIcon fontSize="small" /></IconButton>
        </Box>

        <Box sx={{ p: 3 }}>
          {!submitted ? (
            <>
              <Alert severity="info" sx={{ mb: 3 }}>
                <strong>Eligibility Criteria:</strong> Students must be between <strong>7 to 15 years of age</strong> to register for exams.
              </Alert>
              
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Student Name"
                    name="studentName"
                    value={formData.studentName}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    error={!!errors.studentName}
                    helperText={errors.studentName}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Date of Birth"
                    name="dob"
                    type="date"
                    value={formData.dob}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.dob}
                    helperText={errors.dob || " "}
                  />
                  {getAgeHint()}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Class"
                    name="class"
                    value={formData.class}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    placeholder="e.g. 5th, 6th, 7th"
                    error={!!errors.class}
                    helperText={errors.class}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Parent / Guardian Name"
                    name="parentName"
                    value={formData.parentName}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    error={!!errors.parentName}
                    helperText={errors.parentName}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Phone Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    inputProps={{ maxLength: 10 }}
                    error={!!errors.phone}
                    helperText={errors.phone}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email Address"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    error={!!errors.email}
                    helperText={errors.email}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    multiline
                    rows={2}
                    error={!!errors.address}
                    helperText={errors.address}
                  />
                </Grid>
              </Grid>

              <Button
                variant="contained"
                fullWidth
                sx={{ mt: 3, borderRadius: 2, textTransform: "none", fontWeight: 600, py: 1.2, background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`, "&:hover": { background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)` } }}
                onClick={handleSubmit}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
              >
                {loading ? "Submitting..." : "Submit Registration"}
              </Button>

              {apiError && <Alert severity="error" sx={{ mt: 2 }}>{apiError}</Alert>}
            </>
          ) : (
            <Box textAlign="center" py={2}>
              <Box
                sx={{
                  width: 72, height: 72, borderRadius: "50%",
                  background: "#e8f5e9", display: "flex",
                  alignItems: "center", justifyContent: "center", mx: "auto", mb: 2,
                }}
              >
                <SchoolIcon sx={{ fontSize: 36, color: "#2e7d32" }} />
              </Box>
              <Typography variant="h6" fontWeight={700} mb={1}>Registration Successful!</Typography>
              <Typography variant="body2" color="text.secondary" mb={3}>
                Your admit card for <strong>{exam?.name}</strong> is ready. Download it and keep it safe for exam day.
              </Typography>
              <Alert severity="info" sx={{ mb: 3, textAlign: "left" }}>
                <strong>Login Credentials for Exam Day:</strong><br />
                Phone: <strong>{formData.phone}</strong> &nbsp;|&nbsp; DOB: <strong>{formData.dob}</strong>
              </Alert>
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={handleDownload}
                fullWidth
                sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, py: 1.2, background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`, "&:hover": { background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)` }, mb: 1.5 }}
              >
                Download Admit Card
              </Button>
              <Button variant="outlined" fullWidth sx={{ borderRadius: 2, textTransform: "none", borderColor: primaryColor, color: primaryColor }} onClick={handleClose}>
                Close
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

// ─── Exam Login Modal ────────────────────────────────────────────────────────

const ExamLoginModal = ({ open, exam, onClose }) => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ phone: "", dob: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const handleChange = (e) => {
    setCredentials((p) => ({ ...p, [e.target.name]: e.target.value }));
    setErrors((p) => ({ ...p, [e.target.name]: "" }));
    setApiError("");
  };

  const validate = () => {
    const e = {};
    if (!/^\d{10}$/.test(credentials.phone)) e.phone = "Enter a valid 10-digit phone number";
    if (!credentials.dob) e.dob = "Date of birth is required";
    return e;
  };

  const handleVerify = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }

    setLoading(true);
    setApiError("");
    try {
      const response = await axios.post(`/api/v1/student/verify`, {
        examId: exam._id,
        phone: credentials.phone,
        dob: credentials.dob,
      });

      if (response.data.success) {
        const student = response.data.student || response.data.data;
        localStorage.setItem(
          "verifiedStudent",
          JSON.stringify(student)
        );
        navigate(`/write-exam/${exam._id}`, {
          state: { studentData: student, exam },
        });
      } else {
        setApiError(response.data.message || "Verification failed. Please check your credentials.");
      }
    } catch (err) {
      setApiError(
        err?.response?.data?.message ||
        "Verification failed. Please check your phone number and date of birth."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setCredentials({ phone: "", dob: "" });
    setErrors({});
    setApiError("");
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "95vw", sm: 420 },
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          outline: "none",
        }}
      >
        <Box sx={{ p: 3, pb: 2, borderBottom: "1px solid", borderColor: "divider", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <Box>
            <Typography variant="h6" fontWeight={700} sx={{ color: primaryColor }}>Student Verification</Typography>
            <Typography variant="body2" color="text.secondary">{exam?.name}</Typography>
          </Box>
          <IconButton onClick={handleClose} size="small"><CloseIcon fontSize="small" /></IconButton>
        </Box>

        <Box sx={{ p: 3 }}>
          <Alert severity="info" sx={{ mb: 3 }}>
            Enter the phone number and date of birth you used during registration.
          </Alert>

          {apiError && <Alert severity="error" sx={{ mb: 2 }}>{apiError}</Alert>}

          <Stack spacing={2}>
            <TextField
              label="Registered Phone Number"
              name="phone"
              value={credentials.phone}
              onChange={handleChange}
              fullWidth
              inputProps={{ maxLength: 10 }}
              error={!!errors.phone}
              helperText={errors.phone}
              placeholder="10-digit mobile number"
            />
            <TextField
              label="Date of Birth"
              name="dob"
              type="date"
              value={credentials.dob}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              error={!!errors.dob}
              helperText={errors.dob}
            />
          </Stack>

          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 3, borderRadius: 2, textTransform: "none", fontWeight: 600, py: 1.4, background: "#2e7d32", "&:hover": { background: "#1b5e20" } }}
            onClick={handleVerify}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <LoginIcon />}
          >
            {loading ? "Verifying..." : "Verify & Start Exam"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

// ─── Main Page ───────────────────────────────────────────────────────────────

const OnlineExams = () => {
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  const [regOpen, setRegOpen] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);

  const [loginOpen, setLoginOpen] = useState(false);
  const [loginExam, setLoginExam] = useState(null);

  const getAllExams = async () => {
    try {
      const response = await axios.get(`/api/v1/exam/active`);
      setExams(response.data.data || []);
    } catch (error) {
      console.error("Failed to fetch exams:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllExams();
  }, []);

  const handleRegister = (exam) => {
    setSelectedExam(exam);
    setRegOpen(true);
  };

  const handleStartExam = (exam) => {
    setLoginExam(exam);
    setLoginOpen(true);
  };

  return (
    <>
      <Navbar />
      <PageTitle
        title="Online Exams - Shree Mangalam School"
        description="Take your online exams at Shree Mangalam School. Convenient and accessible exam platform for all students."
        url="/online-exams"
        keywords="online exams, Shree Mangalam exams, RIMC exams, sainik school exams, secure exam portal"
      />
      <Header image={OnlineExamsBanner} alt={"Shree Mangalam School"} />

      <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, md: 4 }, py: 5 }}>
        <Box mb={4}>
          <Typography variant="h4" fontWeight={700} color="text.primary" sx={{ color: primaryColor }}>
            Available Exams
          </Typography>
          <Typography variant="body1" color="text.secondary" mt={0.5}>
            Register for an exam and download your admit card. You can start the exam on or after the start date.
          </Typography>
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" py={8}>
            <CircularProgress sx={{ color: primaryColor }} />
          </Box>
        ) : exams.length === 0 ? (
          <Box textAlign="center" py={8}>
            <AssignmentIcon sx={{ fontSize: 60, color: "text.disabled" }} />
            <Typography variant="h6" color="text.secondary" mt={2}>No active exams found.</Typography>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {exams.map((exam) => (
              <Grid item xs={12} sm={6} md={4} key={exam._id}>
                <ExamCard
                  exam={exam}
                  onRegister={handleRegister}
                  onStartExam={handleStartExam}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>

      {selectedExam && (
        <RegistrationModal
          open={regOpen}
          exam={selectedExam}
          onClose={() => { setRegOpen(false); setSelectedExam(null); }}
        />
      )}

      {loginExam && (
        <ExamLoginModal
          open={loginOpen}
          exam={loginExam}
          onClose={() => { setLoginOpen(false); setLoginExam(null); }}
        />
      )}
      <Footer />
    </>
  );
};

export default OnlineExams;